import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";
import { ButtonWrap } from "shared/Button/styled";
import { InputWrap, WrapMessage } from "shared/Input/styled";

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 0px 20px 0px;
  @media (min-width: 769px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const TitleText = styled.div`
  position: relative;
  font-size: 36px;
  font-family: ${fonts.abhayaBold};
  color: ${colors.GREY_DARK};

  .icon {
    position: absolute;
    top: 15px;
    right: 0px;
    width: 25px;
    height: 25px;
    cursor: pointer;
  }

  @media (min-width: 769px) {
    .icon {
      display: none;
    }
  }
`;

export const TitleButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .hide-mobile {
    display: none;
  }
  ${ButtonWrap} {
    width: 49%;
  }
  @media (min-width: 769px) {
    ${ButtonWrap} {
      margin-left: 10px;
      width: 100%;
    }
    .hide-mobile {
      display: inline-block;
    }
  }
`;

export const EmptyPlace = styled.div`
  font-size: 24px;
  font-family: ${fonts.abhayaRegular};
  color: ${colors.GREY};
  background: linear-gradient(180deg, rgba(242, 243, 245, 0.5) 0%, rgba(242, 243, 245, 0) 100%);
  border-radius: 20px;
  height: 300px;
  text-align: center;
  padding-top: 50px;
`;

export const ListContainer = styled.div``;

export const ItemHead = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 769px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
  }
  border-top: 1px solid ${colors.GREY_SEMILIGHT};
  &:last-child {
    border-bottom: 1px solid ${colors.GREY_SEMILIGHT};
  }
`;

export const ItemContent = styled.div`
  padding: 0px 40px;
`;

export const LeftCol = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 20px;
  padding: 10px 0px;

  @media (min-width: 769px) {
    min-height: auto;
    padding: 0px;
  }
`;

export const IconWrapper = styled.div`
  cursor: pointer;
  .icon {
    ${(props) => props.isOpen && "transform: rotate(90deg);"}
  }
`;

export const NoImage = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${colors.GREY_LIGHT};
  color: ${colors.GREY_DARK};
  border-radius: 5px;
  .icon-creator {
    height: 40px;
    width: 40px;
    stroke: ${colors.GREY};
  }
`;

export const RecipeImage = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  margin: 0px 10px 0px 15px;
  img {
    object-fit: cover;
    object-position: center center;
    width: 40px;
    height: 40px;
    border-radius: 5px;
  }
`;

export const YieldText = styled.div`
  font-family: ${fonts.latoRegular};
  font-size: 12px;
  color: ${colors.GREY_SEMIDARK};
  margin-right: 5px;
`;

export const YieldCounter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 10px;
  border: 1px solid ${colors.GREY_SEMILIGHT};
  border-radius: 20px;
  font-family: ${fonts.latoBold};
  font-size: 12px;

  .icon {
    width: 12px;
    height: 12px;
    fill: ${colors.GREY};
    stroke: ${colors.GREY};

    &-minus {
      stroke: none;
      margin: -4px 10px 0px 0px;
    }

    &-plus {
      fill: ${colors.BLUE_LINK};
      stroke: ${colors.BLUE_LINK};
      margin-left: 10px;
    }
  }
`;

export const YieldCounterWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 20px;

  @media (max-width: 768px) {
    flex: 1;
    padding-left: 30px;
  }

  .icon-yield {
    margin-right: 5px;
    cursor: auto;
  }
`;

export const RightCol = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 10px 10px 0;
  @media (min-width: 769px) {
    padding: 0 0 0 15px;
  }
  .icon {
    display: block;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  .icon-new_tab {
    stroke: ${colors.GREY_DARK};
    fill: ${colors.GREY_DARK};
    margin-right: 20px;
  }

  .icon-delete {
    stroke: ${colors.RED};
    fill: ${colors.RED};
    margin-right: 10px;
  }
`;

export const Description = styled.div``;

export const RecipeTitle = styled.div`
  font-family: ${fonts.latoBold};
  font-size: 16px;
  color: ${colors.GREY_DARK};
`;

export const CollectionsNames = styled.div`
  font-family: ${fonts.latoRegular};
  font-size: 12px;
`;

export const CollectionName = styled.span`
  color: ${(props) => props.color};
`;

export const GroceryIngredientContainer = styled.div``;

export const IngredientTitle = styled.div`
  margin: 10px 0px;
  font-family: ${fonts.latoRegular};
  font-size: 14px;
  color: ${colors.GREY};
`;

export const IngredientItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 10px 0px;
  cursor: pointer;
`;

export const CheckWrap = styled.div`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin: 5px 15px 0px 0px;
  border-radius: 5px;
  border: 1px solid ${colors.GREY};
  .icon-check {
    display: none;
    width: 18px;
    height: 18px;
    stroke: ${colors.WHITE};
    fill: ${colors.WHITE};
  }
`;

export const ItemText = styled.div``;

export const ItemName = styled.div`
  font-family: ${fonts.latoBold};
  font-size: 14px;
  color: ${colors.GREY_DARK};
  text-transform: lowercase;
`;

export const ItemDescription = styled.div`
  font-family: ${fonts.latoRegular};
  font-size: 12px;
  color: ${colors.GREY};
`;

export const CompletedIngredientItemsContainer = styled.div`
  ${CheckWrap} {
    background-color: ${colors.BLUE_LINK};
    border: 1px solid ${colors.BLUE_LINK};
    .icon-check {
      display: block;
    }
  }

  ${ItemName} {
    text-decoration: line-through;
    font-family: ${fonts.latoRegular};
    color: ${colors.GREY};
  }
`;

export const EmailModalTitle = styled.div`
  margin-bottom: 15px;
  font-family: ${fonts.abhayaBold};
  font-size: 24px;
  line-height: 1.2;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 85%;
  &:first-letter {
    text-transform: uppercase;
  }
  @media (min-width: 769px) {
    line-height: 1;
  }
`;

export const EmailButtonsWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  button {
    width: 100%;
    :first-child {
      margin-right: 20px;
    }
  }
`;

export const EmailsWrapper = styled.div`
  display: flex;
  margin-bottom: 20px;
  flex-direction: column;
  ${InputWrap} {
    max-width: 695px;
    width: 100%;
  }
  ${WrapMessage} {
    position: initial;
  }
  button {
    margin-top: 12px;
    height: 46px;
  }
  @media (min-width: 769px) {
    flex-direction: row;
    button {
      margin-left: 12px;
      margin-top: 0;
    }
  }
`;
